import '../../capabilities/registry';
import { registerDeployPlugin } from '../../core/registry';
import { registerResourceConfigs } from '../../platform/resource-watch';
import { registerSkuModuleMeta } from '../../platform/scene-layout/moduleMetaRegistry';
import { msHeadless } from './headless';
import { MS_RESOURCE_CONFIGS, MS_SKU_MODULE_META } from './resourceConfigs';

registerSkuModuleMeta('ModelSubscription', MS_SKU_MODULE_META);
registerResourceConfigs('ModelSubscription', MS_RESOURCE_CONFIGS);

registerDeployPlugin({
  headless: msHeadless,
  loadUi: () =>
    import('./ui').then((m) => ({
      ResourceEditor: m.MsResourceEditor,
      ResourcePreview: m.MsResourcePreview,
    })),
});

export type { MsFieldKey } from './fields';
export type { ModelSubscriptionDetail, ModelSubscriptionFormSwitches } from './types/detail';
export { resetMsSkuModuleFields } from './skuModuleReset';
export {
  MS_SKU_MODULE_KEYS,
  MS_SKU_MODULE_LIST,
  MS_DIRECT_CREATE_STEPS,
  MS_DIRECT_MERGED_MODULES,
  filterMsSkuModules,
  filterMsDirectMergedModules,
} from './scenes';
export { buildMsFreshDisplayConfig } from './display';
export { buildMsMergedDisplayConfig } from './display/mergeDisplayConfig';
export { MS_PRODUCT_CARD_EXCLUDED_DISPLAY_IDS, filterMsProductCardDisplayRows } from './display/productCard';
export { buildMsSkuCapabilityOptions } from './skuCapabilityOptions';
export {
  resolveMsOrderPreviewExtraWatchFields,
  resolveMsSkuPreviewExtraWatchFields,
  resolveMsOrderInnerRootWatchFields,
} from './orderPreviewWatch';
export { MS_ORDER_RESOURCE_DISPLAY_IDS, MS_RESOURCE_CONFIGS, MS_SKU_MODULE_META, MS_TOKEN_RESOURCE_CONFIG } from './resourceConfigs';
export { MsResourceEditor, useMsDeployFormLinkage } from './ui/ResourceEditor';
export type { MsResourceEditorProps } from './ui/ResourceEditor';
export { MsResourcePreview } from './ui/ResourcePreview';
export { buildMsDeliveryMetadata, buildMsOrderDeliveryMetadata } from './headless/deliveryMetadata';
export type {
  BuildMsDeliveryMetadataInput,
  BuildMsOrderDeliveryMetadataContext,
  ModelSubscriptionDeliveryMetadata,
} from './headless/deliveryMetadata';
export { msDetailToForm, hydrateModelSubscriptionDetailToForm } from './hydrateFromApiDetail';
export { buildMsSubscriptionPayload } from './headless/payload';
export { MS_MODULES, MS_MODULE_MAP, MS_CAPABILITIES } from './modules';
export type {
  ModelSubscriptionModel,
  ModelSubscriptionModelMapping,
  ModelSubscriptionPathType,
  ModelSubscriptionTargetService,
  ModelSubscriptionTargetServicePreset,
} from './types';
